import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import ImageUploadComponent from '../../Common/ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import { amenitiesUploadDir } from '../../../config';
import { photosShow } from '../../../helpers/photosShow';

import s from './ListSettingsForm.css';
import bt from '../../../components/commonStyle.css';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';

class AddListSettingsForm extends Component {

  static propTypes = {
    fieldType: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      fieldType: null
    }
  }

  UNSAFE_componentWillMount() {
    const { fieldType } = this.props;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fieldType } = nextProps;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }


  handleChange = async () => {
    const { change } = this.props;
    await change('image', null)
  }

  success = async (file, fromServer) => {
    const { change } = this.props
    let fileName = fromServer.file.filename;
    change('image', fileName)
  }

  render() {
    const { error, handleSubmit, submitting, typeId, image, roomTypeLoader1 } = this.props;
    const { formatMessage } = this.props.intl;
    const { fieldType } = this.state;
    let path = photosShow(amenitiesUploadDir);
    return (
      <div className={cx(s.formMaxWidth, 'maxwidthcenter', 'empty')}>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <Field
            name="itemName"
            type="text"
            component={InputFieldComponent}
            label={formatMessage(messages.addItemNew)}
            inputClass={cx(bt.commonControlInput)}
            formGroupClass={bt.space4}
            placeholder={formatMessage(messages.itemNamePlaceHolder)}
          />
          {
            (typeId === 11 || typeId === 10 || typeId === 12 || typeId === 1 || typeId === 3) &&
            <div className={bt.space4}>
              <p className={s.labelTextNew}><FormattedMessage {...messages.IconLabel} /></p>
              <div className={bt.picContainerMain}>
                <div className={cx(bt.picContainer)}>
                  <p className={cx('hidden-md hidden-lg hidden-sm')}>&nbsp;</p>
                  <CommonImageDisplay
                    loader={roomTypeLoader1}
                    image={path + image}
                    isDelete={true}
                    isDefaultPic={image ? false : true}
                    deleteImage={this.handleChange}
                  />
                </div>
              </div>
              <div className={cx(s.spaceTop2)}>
                <div className={cx(s.fullWidth, bt.btnPrimary, s.noPadding, 'photoUploadBtn')}>
                  <ImageUploadComponent
                    defaultMessage={formatMessage(messages.UploadImage)}
                    componentConfig={{
                      iconFiletypes: ['.jpg', '.png', '.jpeg'],
                      multiple: false,
                      showFiletypeIcon: false,
                      postUrl: '/uploadAmenities'
                    }}
                    loaderName={'roomTypeLoader1'}
                    success={this.success}
                  />
                </div>
              </div>
            </div>
          }
          {
            fieldType == "numberType" && <div>
              <Field
                name="otherItemName"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.addOtherItem)}
                inputClass={cx(bt.commonControlInput)}
                formGroupClass={bt.space4}
                placeholder={formatMessage(messages.otherItemPlaceHolder)}
              />
              <Field
                name="startValue"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.startValue)}
                inputClass={cx(bt.commonControlInput)}
                formGroupClass={bt.space4}
                placeholder={formatMessage(messages.startValuePlaceHolder)}
              />
              <Field
                name="endValue"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.endValue)}
                inputClass={cx(bt.commonControlInput)}
                formGroupClass={bt.space4}
                placeholder={formatMessage(messages.endValuePlaceHolder)}
              />
            </div>
          }
          <div className={cx(s.spaceTop3, 'singleButtonFlexEnd')}>
            <Button className={cx(bt.btnPrimaryBorder, bt.btnLarge)} type="submit" disabled={submitting}>
              {formatMessage(messages.add)}
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

AddListSettingsForm = reduxForm({
  form: "AddListSettingsForm",
  validate,
})(AddListSettingsForm);

const selector = formValueSelector("AddListSettingsForm");

const mapState = (state) => ({
  typeId: selector(state, 'typeId'),
  image: selector(state, 'image'),
  roomTypeLoader1: state?.loader?.roomTypeLoader1
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AddListSettingsForm)));